import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/39_field/39_field"
 * Contains 1 texture(s)
 */
export class Mobile39FieldAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/39_field/39_field';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '39_field.jpg'
    ] as const;
}
